import React from 'react';
import { FaCode, FaMobileAlt, FaCubes, FaServer } from 'react-icons/fa';

const projects = [
    {
        icon: FaCode,
        category: 'Web',
        title: 'Vibeu.tech',
        description: 'A portfolio website detailing projects and ideas I have done.',
        status: 'In Progress',
    },
    {
        icon: FaMobileAlt,
        category: 'Mobile',
        title: 'Gro Mental Health',
        description: 'A cross-platform mobile app shipped to iOS and (pending) Android.',
        status: 'On Hold',
    },
    {
        icon: FaCubes,
        category: 'Blockchain',
        title: 'FinalChain',
        description: 'A self constructed blockchain built from scratch for my final.',
        status: 'Complete',
    },
    {
        icon: FaServer,
        category: 'IT / Infrastructure',
        title: 'Vibey Mesh',
        description: 'A server setup, automation, or infrastructure project.',
        status: 'In Progress',
    },
];

const statusColors = {
    'In Progress': 'rgba(249,115,22,0.15)',
    'On Hold':     'rgba(139,92,246,0.15)',
    'Complete':    'rgba(34,197,94,0.15)',
};
const statusBorders = {
    'In Progress': 'rgba(249,115,22,0.3)',
    'On Hold':     'rgba(139,92,246,0.3)',
    'Complete':    'rgba(34,197,94,0.3)',
};
const statusText = {
    'In Progress': 'rgba(255,185,110,0.9)',
    'On Hold':     'rgba(196,181,253,0.9)',
    'Complete':    'rgba(134,239,172,0.9)',
};

const Blog = () => {
    return (
        <section id="projects" className="section-divider py-24" style={{ background: 'rgba(7,8,15,0.88)' }}>
            <div className="container max-w-5xl mx-auto px-6 lg:px-8">

                <div className="flex items-end justify-between mb-12">
                    <div>
                        <span className="text-orange-400 text-xs tracking-widest uppercase font-medium">Work</span>
                        <h2 className="text-4xl font-bold text-white mt-3">Projects</h2>
                    </div>
                    <a
                        href="https://github.com/Vybeu"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-orange-400 hover:text-orange-300 transition-colors tracking-wide hidden sm:block cursor-pointer"
                    >
                        View GitHub &rarr;
                    </a>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    {projects.map(({ icon: Icon, category, title, description, status }) => (
                        <div key={category} className="glass-card p-6">
                            <div className="flex items-center gap-3 mb-4">
                                <div
                                    className="w-9 h-9 flex items-center justify-center rounded-xl flex-shrink-0"
                                    style={{
                                        background: 'rgba(249,115,22,0.13)',
                                        border: '1px solid rgba(249,115,22,0.26)',
                                        color: 'rgba(255,185,110,0.88)',
                                    }}
                                >
                                    <Icon size={15} />
                                </div>
                                <span className="text-xs text-orange-400 tracking-widest uppercase font-medium">
                                    {category}
                                </span>
                            </div>
                            <h3 className="font-semibold text-lg mb-2" style={{ color: 'rgba(255,255,255,0.92)' }}>
                                {title}
                            </h3>
                            <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.46)' }}>
                                {description}
                            </p>
                            <div className="mt-5">
                                <span
                                    className="inline-block px-3 py-1 text-xs rounded-full font-medium"
                                    style={{
                                        background: statusColors[status],
                                        border: `1px solid ${statusBorders[status]}`,
                                        color: statusText[status],
                                    }}
                                >
                                    {status}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-6 sm:hidden text-center">
                    <a
                        href="https://github.com/Vybeu"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-orange-400 hover:text-orange-300 transition-colors cursor-pointer"
                    >
                        View all on GitHub &rarr;
                    </a>
                </div>

            </div>
        </section>
    );
};

export default Blog;
